import { render, staticRenderFns } from "./OtherUpload.vue?vue&type=template&id=71eadf25&scoped=true&"
import script from "./OtherUpload.vue?vue&type=script&lang=js&"
export * from "./OtherUpload.vue?vue&type=script&lang=js&"
import style0 from "./OtherUpload.vue?vue&type=style&index=0&id=71eadf25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eadf25",
  null
  
)

export default component.exports